import { Link } from 'react-router-dom';
import { useDarkHero } from '@/contexts/NavbarContext';

const features = [
  { icon: 'ri-building-2-line', title: 'Yurtdışı Depolama', desc: 'Stoklarınızı yurtdışında depolayarak farklı siparişlerin bir noktada birleştirilip hazır hale getirilmesini sağlıyoruz.' },
  { icon: 'ri-archive-2-line', title: 'Sipariş Birleştirme', desc: 'Farklı siparişlerin bir noktada birleştirilip hazır hale getirilmesi gibi talepleriniz için kullanabilirsiniz.' },
  { icon: 'ri-box-3-line', title: 'Ambalajlama', desc: 'Yurtdışında ambalajlama taleplerinize özel çözümler sunuyoruz.' },
  { icon: 'ri-refresh-line', title: 'Yeniden Dağıtım', desc: 'Yurtdışında yeniden dağıtım gibi taleplerinize özel çözümler sunuyoruz.' },
  { icon: 'ri-global-line', title: 'Uluslararası Kapsam', desc: 'Dünyanın her noktasında fulfillment hizmetlerimizden yararlanabilirsiniz.' },
  { icon: 'ri-customer-service-2-line', title: 'Uzman Destek', desc: 'Farklı soru ve talepleriniz için uzman ekiplerimizden destek alabilirsiniz.' },
];

const steps = [
  { icon: 'ri-store-2-line', title: 'Sipariş Alımı', desc: 'Müşteriniz sipariş verir, sistem otomatik olarak fulfillment merkezimize iletir.' },
  { icon: 'ri-archive-2-line', title: 'Depodan Hazırlık', desc: 'Ürününüz yurtdışı depomuzdaki stoktan hazırlanır.' },
  { icon: 'ri-box-3-line', title: 'Paketleme', desc: 'Markanıza uygun ambalajlama ile profesyonelce paketlenir.' },
  { icon: 'ri-truck-line', title: 'Teslimat', desc: 'Yerel dağıtım ağımızla müşterinize hızla teslim edilir.' },
];

export default function FulfillmentPage() {
  useDarkHero(true);
  return (
    <main className="min-h-screen" style={{ background: 'var(--bg)' }}>
      {/* Hero */}
      <section className="relative min-h-[680px] flex items-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=modern%20automated%20warehouse%20fulfillment%20center%20interior%2C%20tall%20shelving%20racks%20with%20products%2C%20workers%20picking%20orders%2C%20conveyor%20systems%2C%20bright%20industrial%20lighting%20with%20warm%20orange%20tones%2C%20organized%20inventory%20management%2C%20wide%20angle%20perspective%2C%20professional%20logistics%20photography&width=1920&height=680&seq=fulfillment-hero-01&orientation=landscape"
            alt="Fulfillment"
            loading="eager"
            fetchPriority="high"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0" style={{ background: 'linear-gradient(105deg, rgba(8,10,20,0.92) 0%, rgba(12,18,38,0.80) 55%, rgba(8,10,20,0.50) 100%)' }} />
        </div>

        <div className="absolute inset-0 opacity-20">
          <div className="absolute top-20 left-20 w-80 h-80 rounded-full" style={{ background: 'var(--orange)', filter: 'blur(120px)' }} />
        </div>

        <div className="w-full max-w-6xl mx-auto px-6 lg:px-10 relative z-10 pt-36 pb-24">
          <div className="flex items-center gap-2 mb-8">
            <Link to="/hizmetler" className="text-sm hover:opacity-80 transition-opacity" style={{ color: 'rgba(255,255,255,0.55)', textDecoration: 'none' }}>Hizmetler</Link>
            <i className="ri-arrow-right-s-line" style={{ color: 'rgba(255,255,255,0.35)', fontSize: 14 }} />
            <span className="text-sm font-medium" style={{ color: 'var(--orange)' }}>Fulfillment</span>
          </div>

          <div className="flex flex-col lg:flex-row items-start lg:items-center gap-16">
            <div className="flex-1">
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full mb-6" style={{ background: 'rgba(232,97,26,0.18)', border: '1px solid rgba(232,97,26,0.45)' }}>
                <i className="ri-archive-2-line" style={{ color: 'var(--orange)' }} />
                <span className="text-sm font-semibold" style={{ color: 'var(--orange)' }}>Fulfillment</span>
              </div>

              <h1 className="text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
                Depolama ve<br />
                <span style={{ color: 'var(--orange)' }}>Fulfillment Çözümleri</span>
              </h1>

              <p className="text-lg mb-8" style={{ color: 'rgba(255,255,255,0.82)', lineHeight: 1.8, maxWidth: 560 }}>
                Yurtdışında depolama, ambalajlama ve yeniden dağıtım gibi taleplerinize özel çözümler sunuyoruz. Stoklarınızı yurtdışında depolayarak siparişlerinizi hızla karşılıyoruz.
              </p>

              <div className="flex flex-wrap gap-4">
                <Link to="/iletisim" className="inline-flex items-center gap-2 px-8 py-4 rounded-xl font-semibold text-white cursor-pointer whitespace-nowrap hover:opacity-90 transition-opacity" style={{ background: 'var(--orange)', textDecoration: 'none' }}>
                  <i className="ri-mail-send-line" />Teklif Al
                </Link>
                <a href="tel:+908502420822" className="inline-flex items-center gap-2 px-8 py-4 rounded-xl font-semibold cursor-pointer whitespace-nowrap hover:opacity-80 transition-opacity" style={{ background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.28)', color: 'white', textDecoration: 'none' }}>
                  <i className="ri-phone-line" />0850 242 0 822
                </a>
              </div>
            </div>

            <div className="flex-shrink-0 grid grid-cols-2 gap-3">
              {[
                { val: 'Depo', lbl: 'Yurtdışı' },
                { val: 'Paket', lbl: 'Ambalaj' },
                { val: 'Hızlı', lbl: 'Dağıtım' },
                { val: '7/24', lbl: 'Destek' },
              ].map((s, i) => (
                <div key={i} className="text-center px-8 py-6 rounded-2xl" style={{ background: 'rgba(255,255,255,0.09)', border: '1px solid rgba(255,255,255,0.18)', backdropFilter: 'blur(12px)' }}>
                  <div className="text-2xl font-bold mb-1" style={{ color: 'var(--orange)' }}>{s.val}</div>
                  <div className="text-xs" style={{ color: 'rgba(255,255,255,0.65)' }}>{s.lbl}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Process steps */}
      <section className="py-20" style={{ background: 'var(--surface)', borderBottom: '1px solid var(--border)' }}>
        <div className="max-w-6xl mx-auto px-6 lg:px-10">
          <div className="text-center mb-14">
            <h2 className="text-3xl font-bold mb-3" style={{ color: 'var(--text1)' }}>Fulfillment Süreci</h2>
            <p className="text-sm" style={{ color: 'var(--text3)' }}>Siparişten teslimata 4 adımda sorunsuz fulfillment.</p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {steps.map((s, i) => (
              <div key={i} className="p-6 rounded-2xl text-center" style={{ background: 'var(--bg)', border: '1px solid var(--border)' }}>
                <div className="w-14 h-14 flex items-center justify-center rounded-2xl mx-auto mb-4" style={{ background: 'rgba(232,97,26,0.12)', border: '1px solid rgba(232,97,26,0.25)' }}>
                  <i className={`${s.icon} text-2xl`} style={{ color: 'var(--orange)' }} />
                </div>
                <div className="text-xs font-bold mb-1" style={{ color: 'var(--orange)' }}>ADIM {i + 1}</div>
                <h3 className="font-bold text-sm mb-2" style={{ color: 'var(--text1)' }}>{s.title}</h3>
                <p className="text-xs leading-relaxed" style={{ color: 'var(--text3)' }}>{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="py-20">
        <div className="max-w-6xl mx-auto px-6 lg:px-10">
          <div className="flex flex-col lg:flex-row gap-14 items-center mb-16">
            <div className="flex-shrink-0 w-full lg:w-[420px] h-[280px] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=warehouse%20worker%20scanning%20barcode%20on%20package%2C%20fulfillment%20center%20operations%2C%20shelves%20with%20inventory%20in%20background%2C%20professional%20logistics%20worker%2C%20warm%20industrial%20lighting%2C%20focused%20work%20environment%2C%20clean%20organized%20storage&width=420&height=280&seq=fulfillment-content-01&orientation=landscape"
                alt="Fulfillment operasyon"
                loading="lazy"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="flex-1">
              <h2 className="text-3xl font-bold mb-4" style={{ color: 'var(--text1)' }}>Fulfillment Hizmetlerimiz</h2>
              <p className="text-sm leading-relaxed mb-4" style={{ color: 'var(--text3)' }}>
                CargoNet fulfillment servisini, stoklarınızı yurtdışında depolayarak, farklı siparişlerin bir noktada birleştirilip hazır hale getirilmesi gibi talepleriniz için kullanabilirsiniz.
              </p>
              <p className="text-sm leading-relaxed mb-6" style={{ color: 'var(--text3)' }}>
                Yurtdışında ambalajlama ve yeniden dağıtım gibi taleplerinize özel çözümler sunuyoruz. İşletmenizin büyümesini destekleyen kapsamlı fulfillment çözümleri.
              </p>
              <p className="text-sm font-semibold" style={{ color: 'var(--text2)' }}>
                Destek hattı: <a href="tel:+908502420822" style={{ color: 'var(--orange)' }}>0850 242 0 822</a> – <a href="mailto:cs@cargonet.com.tr" style={{ color: 'var(--orange)' }}>cs@cargonet.com.tr</a>
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {features.map((f, i) => (
              <div key={i} className="p-6 rounded-2xl" style={{ background: 'var(--surface)', border: '1px solid var(--border)' }}>
                <div className="w-12 h-12 flex items-center justify-center rounded-xl mb-4" style={{ background: 'rgba(232,97,26,0.1)' }}>
                  <i className={`${f.icon} text-xl`} style={{ color: 'var(--orange)' }} />
                </div>
                <h3 className="font-bold text-sm mb-2" style={{ color: 'var(--text1)' }}>{f.title}</h3>
                <p className="text-xs leading-relaxed" style={{ color: 'var(--text3)' }}>{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20" style={{ background: 'var(--surface)', borderTop: '1px solid var(--border)' }}>
        <div className="max-w-3xl mx-auto px-6 text-center">
          <h2 className="text-2xl font-bold mb-3" style={{ color: 'var(--text1)' }}>Fulfillment Hizmeti İçin Teklif Alın</h2>
          <p className="mb-8 text-sm" style={{ color: 'var(--text3)' }}>Uzman ekibimiz en uygun çözümü sizin için hazırlasın.</p>
          <div className="flex flex-wrap justify-center gap-3">
            <Link to="/iletisim" className="inline-flex items-center gap-2 px-8 py-3 rounded-xl font-semibold text-white cursor-pointer whitespace-nowrap" style={{ background: 'var(--orange)', textDecoration: 'none' }}>
              <i className="ri-mail-send-line" />Teklif Al
            </Link>
            <Link to="/hizmetler" className="inline-flex items-center gap-2 px-8 py-3 rounded-xl font-semibold cursor-pointer whitespace-nowrap" style={{ background: 'var(--bg)', border: '1px solid var(--border)', color: 'var(--text1)', textDecoration: 'none' }}>
              <i className="ri-arrow-left-line" />Tüm Hizmetler
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
}
